var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BaseHeader'),_c('main',{class:_vm.$style.main},[_c('BaseContainer',[_c('BaseEmpty',[_vm._v(" "+_vm._s(_vm.$t('coming-soon').toUpperCase())+" ")])],1)],1),_c('BaseFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }